// ---------------------------------------------------------------------------
// Capability flags — declarações de "esse pedaço de dado já é fonte da verdade
// ou ainda é placeholder". Permite plugar a tela ao backend pedaço por pedaço,
// sem mexer em JSX quando uma capacidade nova entra em produção.
//
// Quando uma flag passa pra true, o componente correspondente troca placeholder
// por dado real automaticamente. Não usar para feature flags de A/B — esse não
// é o propósito.
//
// Ligar/desligar cada flag pede aprovação consciente do produto + backend pronto
// pra entregar o dado.
// ---------------------------------------------------------------------------

const ROUTING_CAPS = {
   // Otimizador automático de rotas. v1.1 (handoff 0030): chamada ao backend
   // (Google optimizeTours) via modal de frota → job assíncrono → polling →
   // recarga do snapshot. Ligado: o botão "Otimizar" da toolbar dispara o fluxo.
   hasOptimizer: true,

   // Tracking em tempo real do técnico no mapa. v2 — depende do app do técnico
   // reportando posição GPS via routing_item_status_events.gps_*.
   hasGeolocation: false,

   // Eventos populados via app do técnico (source=TECHNICIAN_APP). v2.
   hasTelemetry: false,

   // Jornada de trabalho por técnico/dia (start/end). Tabela
   // technician_shifts ainda não existe.
   hasShifts: false,

   // Veículo + placa por técnico. Hoje hr/employees não tem; precisaria
   // tabela vehicles ou colunas em employees.
   hasVehicles: false,

   // Janelas de atendimento populadas (customer_window_start/end).
   // v1 — colunas existem; ligadas se o operador usar o campo.
   hasWindows: true,

   // Latitude/longitude do endereço. v1 — colunas address_latitude/longitude
   // já existem em routing_schedule_items, vêm preenchidas pelo Refiltek.
   hasCoordinates: true,
};

export default ROUTING_CAPS;
